import Exit from "@assets/images/icons/exit_to_app.svg";
import { profileType } from "../../../utils/enum";

export const addToZoho = {
  icon: <Exit />,
  name: "Export to Zoho",
};

export const addToHubspot = {
  icon: <Exit />,
  name: "Export to Hubspot",
};

export const tabDataHandler = [
  {
    name: "Importers-Exporters",
    value: profileType.company,
  },
  {
    name: "Logistics Companies",
    value: profileType.logistics,
  },
];

export const shipmentsFilters = {
  tagList: [],
  dataSource: [],
};

export let shipmentsPayload = {
  type: profileType.shipments,
  filters: { ...shipmentsFilters },
  company_name: "",
  from: 0,
  sort: "desc",
};

export const pendoEventType = {
  shipments: "_shipments_",
};
